import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PaymentPlanHint } from './PaymentPlanHint'

export const EstimatedDueDatesHint: FC = () => {
  const { t } = useTranslation('global')

  return (
    <PaymentPlanHint
      text={t('PaymentPlanCard.dates-finalized-when-loan-disbursed')}
    />
  )
}
